<template>
  <div
    @click="jumpDetail"
    style="width: 380px; height: 240px"
    class="flex p-4 overflow-hidden bg-white rounded-md shadow mb-5 cursor-pointer"
  >
    <img class="center" :src="props.info.coverUrl" style="width: 160px; height: 210px" />
    <div class="flex-1 mx-3">
      <p class="font-bold">{{ props.info.name }}</p>
      <div class="mt-4 overflow-hidden" style="width: 180px; height: 151px;overflow: hidden;">
        {{ props.info.synopsis }}
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import useJumpWithQuery from "../../hooks/useJumpWithQuery";
import { useRouter } from 'vue-router';
const props = defineProps({
  info: {},
});
console.log(props.info);
const useJump = useJumpWithQuery();

const router = useRouter()
const jumpDetail = () => {
  const href = router.resolve({
    path: '/courseDetail',
    query: {
      courseId: props.info.id,
    }
  })
  window.open(href.href, '_blank')
  // useJump("courseDetail", {
  //   courseId: props.info.id,
  // });
};
</script>
